export default function ReportSignoff({ distributionRoles, signoff, letter = "D", dark = false }) {
  const muted = dark ? "#a8b6cf" : "#6b7280";
  const text = dark ? "#e5eefb" : "#111827";
  const border = dark ? "#334155" : "#e5e7eb";
  const panelBg = dark ? "#111827" : "#f8fafc";

  return (
    <div style={{ marginBottom: "30px" }}>
      <h3 style={{ fontSize: "16px", fontWeight: 600, color: "#374151", marginBottom: "12px" }}>
        Appendix {letter} — Distribution List &amp; Sign-Off
      </h3>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
        <thead>
          <tr style={{ background: "#f9fafb" }}>
            {["Role", "Name", "Date", "Signature"].map((h) => (
              <th key={h} style={{ padding: "8px 12px", textAlign: h === "Role" || h === "Name" ? "left" : "center", borderBottom: `2px solid ${border}`, fontWeight: 700, fontSize: "11px", color: muted }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(distributionRoles?.length ? distributionRoles : ["Chief Audit Executive"]).map((role, i) => (
            <tr key={i} style={{ borderBottom: `1px solid ${border}` }}>
              <td style={{ padding: "10px 12px", fontWeight: 500 }}>{role}</td>
              <td style={{ padding: "10px 12px", borderBottom: "1px dashed #d1d5db", minWidth: "150px" }} />
              <td style={{ padding: "10px 12px", textAlign: "center", borderBottom: "1px dashed #d1d5db", minWidth: "100px" }} />
              <td style={{ padding: "10px 12px", textAlign: "center", borderBottom: "1px dashed #d1d5db", minWidth: "120px" }} />
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: "16px", border: `1px solid ${border}`, borderRadius: "8px", padding: "14px 16px", background: panelBg }}>
        <p style={{ margin: 0, fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.4px", color: muted }}>
          Final Reviewer Sign-off
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "160px 1fr", gap: "8px 16px", marginTop: "10px", fontSize: "12px" }}>
          <span style={{ color: muted, fontWeight: 600 }}>Reviewer</span>
          <span style={{ color: text }}>{signoff?.reviewer || "Not recorded"}</span>
          <span style={{ color: muted, fontWeight: 600 }}>Approval Status</span>
          <span style={{ color: text }}>{signoff?.confirmed ? "Approved for issuance" : "Pending approval"}</span>
          {signoff?.comment ? (
            <>
              <span style={{ color: muted, fontWeight: 600 }}>Management Sign-off Note</span>
              <span style={{ color: text, whiteSpace: "pre-wrap", lineHeight: 1.6 }}>{signoff.comment}</span>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}